export let stat_depths = {
    mobility: {
        walk_speed:                 [5.0,   5.2,    5.4,    5.6,    5.8,    6.0,    6.2,    6.4,    6.6,    6.8,    7   ],
        strafe_speed:               [4.25,  4.42,   4.59,   4.76,   4.93,   5.10,   5.27,   5.44,   5.61,   5.78,   5.95],
        crouch_speed:               [2.75,  2.86,   2.97,   3.08,   3.19,   3.30,   3.41,   3.52,   3.63,   3.74,   3.85],
        ability_regeneration_rate:  [0.85,  0.9,    0.95,   1,      1.1,    1.2,    1.3,    1.4,    1.5,    1.6,    1.7 ]
    },
    resilience: {
        shield_amount:              [115,   116,    117,    118,    119,    120,    122,    124,    126,    128,    130 ],
        health_amount:              [185,   186,    187,    188,    189,    190,    192,    194,    196,    198,    200 ],
        flinch_resistance:          [0,     1,      2,      3,      4,      5,      6,      7,      8,      9,      10  ],
        resist_against_combatants:  [0,     2,      3,      5,      9,      14,     17,     20,     24,     27,     30  ],
        ability_regeneration_rate:  [0.7,   0.8,    0.9,    1,      1.05,   1.1,    1.2,    1.3,    1.4,    1.55,   1.7 ]
    },
    recovery: {
        health_regen_delay:         [3.25,  3.15,   3.05,   2.95,   2.85,   2.75,   2.65,   2.45,   2.25,   2.05,   1.75],
        shield_regen_delay:         [5.5,   5.4,    5.3,    5.2,    5.1,    5,      4.9,    4.7,    4.5,    4.3,    4   ],
        health_regen_time:          [3.45,  3.35,   3.25,   3.15,   3.05,   2.95,   2.85,   2.65,   2.45,   2.25,   2   ],
        shield_regen_time:          [3.5,   3.4,    3.3,    3.2,    3.1,    3,      2.9,    2.7,    2.5,    2.3,    2   ],
        health_shield_regen_time:   [5.75,  5.65,   5.55,   5.45,   5.35,   5.25,   5.15,   4.95,   4.75,   4.55,   4.25],
        total_regen_time:           [9,     8.8,    8.6,    8.4,    8.2,    9,      7.8,    7.4,    7,      6.6,    6   ],
        ability_regeneration_rate:  [0.7,   0.8,    0.9,    1,      1.1,    1.2,    1.3,    1.4,    1.5,    1.6,    1.7 ]
    },
    discipline: {
        grenade_regeneration_rate:  [0.7,   0.8,    0.9,    1,      1.1,    1.2,    1.3,    1.4,    1.55,   1.75,   2   ]
    },
    intellect: {
        super_regeneration_rate:    [0.69,  0.79,   0.87,   1,      1.06,   1.11,   1.16,   1.22,   1.25,   1.29,   1.3 ]
    },
    strength: {
        melee_regeneration_rate:    [0.7,   0.8,    0.9,    1,      1.1,    1.2,    1.3,    1.4,    1.55,   1.75,   2   ]
    }
};
